import React, { useState } from "react";
import Approvals from "./Approvals";
import Orphans from "./Orphans";

const ApprovalsAndOrphans: React.FC = () => {
  const [approvalsCount, setApprovalsCount] = useState(0);
  const [approvalsStatus, setApprovalsStatus] = useState("pending");
  const [orphansCount, setOrphansCount] = useState(0);

  return (
    <div className="w-full min-h-screen bg-background-default dark:bg-background-dark">
      <div className="max-w-[1400px] mx-auto px-6 py-6">
        <div className="mb-4">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <h1 className="text-3xl font-semibold text-text-primary dark:text-text-primaryDark mb-2">
                Approvals & Orphans
              </h1>
              <p className="text-sm text-text-secondary dark:text-text-secondaryDark">
                Review approvals and resolve orphan deals side by side.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <div className="px-3 py-1.5 rounded-lg border border-divider/60 dark:border-divider-dark/60 bg-background-paper dark:bg-background-paperDark text-xs font-medium text-text-secondary dark:text-text-secondaryDark">
                {approvalsCount}{" "}
                {approvalsCount === 1 ? "Approval" : "Approvals"} (
                {approvalsStatus})
              </div>
              <div className="px-3 py-1.5 rounded-lg border border-divider/60 dark:border-divider-dark/60 bg-background-paper dark:bg-background-paperDark text-xs font-medium text-text-secondary dark:text-text-secondaryDark">
                {orphansCount} {orphansCount === 1 ? "Orphan" : "Orphans"}
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)] gap-6">
          <div className="bg-background-paper dark:bg-background-paperDark rounded-2xl border border-divider/60 dark:border-divider-dark/60 p-4">
            <Approvals
              embedded
              onCountsChange={({ count, status }) => {
                setApprovalsCount(count);
                setApprovalsStatus(status);
              }}
            />
          </div>
          <div className="bg-background-paper dark:bg-background-paperDark rounded-2xl border border-divider/60 dark:border-divider-dark/60 p-4">
            <Orphans embedded onCountsChange={setOrphansCount} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalsAndOrphans;
